import { render } from "./dynamicformtemplate.vue?vue&type=template&id=361e4de8&scoped=true"
import script from "./dynamicformtemplate.js?vue&type=script&lang=js"
export * from "./dynamicformtemplate.js?vue&type=script&lang=js"

import "./dynamicformtemplate.vue?vue&type=style&index=0&id=361e4de8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361e4de8"]])

export default __exports__